import { TaskExecution } from './IDeviceChannel';
export class DeviceTaskTypeInfo {
    constructor() {
        this._type = DeviceTaskType.Unknown;
        this._interfaceType = "";
    }
    get Type() {
        return this._type;
    }
    get InterfaceType() {
        return this._interfaceType;
    }
    set InterfaceType(value) {
        this._interfaceType = value;
        this._type = value;
    }
}
export var IconType;
(function (IconType) {
    IconType[IconType["Unknown"] = 0] = "Unknown";
    IconType[IconType["BlindMotor"] = 1] = "BlindMotor";
    IconType[IconType["DinModule"] = 2] = "DinModule";
    IconType[IconType["DinModuleWithAntenna"] = 3] = "DinModuleWithAntenna";
    IconType[IconType["Remote"] = 4] = "Remote";
    IconType[IconType["RemoteForBlinds"] = 5] = "RemoteForBlinds";
    IconType[IconType["RemoteForFacadeBlinds"] = 6] = "RemoteForFacadeBlinds";
    IconType[IconType["MovementSensor"] = 7] = "MovementSensor";
    IconType[IconType["TemperatureSensor"] = 8] = "TemperatureSensor";
    IconType[IconType["HumiditySensor"] = 9] = "HumiditySensor";
    IconType[IconType["DinPowerMeter"] = 10] = "DinPowerMeter";
    IconType[IconType["Intercom"] = 11] = "Intercom";
    IconType[IconType["SecurityCamera"] = 12] = "SecurityCamera";
    IconType[IconType["Multisensor"] = 13] = "Multisensor";
    IconType[IconType["FloodSensor"] = 14] = "FloodSensor";
    IconType[IconType["FlushMountedReceiver"] = 15] = "FlushMountedReceiver";
    IconType[IconType["FlushMountedBlindController"] = 16] = "FlushMountedBlindController";
    IconType[IconType["FlushMountedDimmer"] = 17] = "FlushMountedDimmer";
    IconType[IconType["FlushMountedRelay"] = 18] = "FlushMountedRelay";
    IconType[IconType["FlushMountedGateController"] = 19] = "FlushMountedGateController";
    IconType[IconType["WindSensor"] = 20] = "WindSensor";
    IconType[IconType["FlushMountedGateAndGatewayController"] = 21] = "FlushMountedGateAndGatewayController";
    IconType[IconType["AirPressureSensor"] = 22] = "AirPressureSensor";
    IconType[IconType["LightBrightnessSensor"] = 23] = "LightBrightnessSensor";
    IconType[IconType["ReedSensor"] = 24] = "ReedSensor";
    IconType[IconType["FlushMountedTransceiver"] = 25] = "FlushMountedTransceiver";
    IconType[IconType["FlushMountedRGBLightController"] = 26] = "FlushMountedRGBLightController";
    IconType[IconType["WallMountedThermoregulator"] = 27] = "WallMountedThermoregulator";
    IconType[IconType["ImpulseCounter"] = 28] = "ImpulseCounter";
    IconType[IconType["FlushMountedFacadeController"] = 29] = "FlushMountedFacadeController";
    IconType[IconType["WallMountedGateController"] = 30] = "WallMountedGateController";
    IconType[IconType["WallMountedRGBLightController"] = 31] = "WallMountedRGBLightController";
    IconType[IconType["WallMountedDimmer"] = 32] = "WallMountedDimmer";
    IconType[IconType["WallMountedRemote"] = 33] = "WallMountedRemote";
    IconType[IconType["DinRelay"] = 34] = "DinRelay";
    IconType[IconType["DinReceiver"] = 35] = "DinReceiver";
    IconType[IconType["DinBlindController"] = 36] = "DinBlindController";
    IconType[IconType["DinTransceiver"] = 37] = "DinTransceiver";
    IconType[IconType["SocketPlugIn"] = 38] = "SocketPlugIn";
    IconType[IconType["WallMountedRelay"] = 39] = "WallMountedRelay";
    IconType[IconType["Retransmitter"] = 40] = "Retransmitter";
})(IconType || (IconType = {}));
export var DeviceTaskType;
(function (DeviceTaskType) {
    DeviceTaskType["Unknown"] = "Unknown";
    DeviceTaskType["SetBlindPosition"] = "IBlindPosition";
    DeviceTaskType["SetBlindPositionSimple"] = "IBlindPositionSimple";
    DeviceTaskType["SetBlindMicroventilation"] = "IMicroventilation";
    DeviceTaskType["TurnOff"] = "IChannelOff";
    DeviceTaskType["TurnOn"] = "IChannelOn";
    DeviceTaskType["TurnOnWithTime"] = "IChannelOnWithTime";
    DeviceTaskType["TogleState"] = "IChannelSwitchState";
    DeviceTaskType["SetLightBrightnessDynamicly"] = "IDynamicLightBrightness";
    DeviceTaskType["SetLightBrightness"] = "ILightBrightness";
    DeviceTaskType["SetLightColor"] = "ILightColor";
    DeviceTaskType["SetLightTemperature"] = "ILightTemperature";
    DeviceTaskType["PairDevice"] = "IPair";
    DeviceTaskType["UnpairDevice"] = "IUnpair";
    DeviceTaskType["IdentifyDevice"] = "IIdentifyDevice";
    DeviceTaskType["GetChannelsState"] = "IGetDeviceState";
    DeviceTaskType["GetPowerMeasurements"] = "IGetPowerMeasurements";
    DeviceTaskType["GetAvailableData"] = "IGetAvailableData";
    DeviceTaskType["MultipleDataRequest"] = "IMultipleDataRequest";
    DeviceTaskType["SetBlindOpenCloseTime"] = "ISetBlindOpenCloseTime";
    DeviceTaskType["SetTemperature"] = "IChangeTemperature";
    DeviceTaskType["SetGatePosition"] = "IGatePosition";
    DeviceTaskType["SetGatewayPosition"] = "IGatewayPosition";
    DeviceTaskType["ChangeGatePositionPulse"] = "IGatePulse";
    DeviceTaskType["ChangeGatewayPositionPulse"] = "IGatewayPulse";
    DeviceTaskType["SetFacadePosition"] = "IFacadePosition";
    DeviceTaskType["GetFacadeType"] = "IGetFacadeType";
    DeviceTaskType["LightRGBW"] = "ILightRGBW";
    DeviceTaskType["PreciseGateControl"] = "IPreciseGateControl";
})(DeviceTaskType || (DeviceTaskType = {}));
export class DeviceResponseTypeInfo {
    constructor() {
        this._type = DeviceResponseType.Unknown;
        this._interfaceType = "";
    }
    get Type() {
        return this._type;
    }
    get InterfaceType() {
        return this._interfaceType;
    }
    set InterfaceType(value) {
        this._interfaceType = value;
        this._type = value;
    }
}
export var DeviceResponseType;
(function (DeviceResponseType) {
    DeviceResponseType["Unknown"] = "Unknown";
    DeviceResponseType["BatteryState"] = "IBatteryState";
    DeviceResponseType["BinarySensorState"] = "IBinarySensor";
    DeviceResponseType["BlindOpenCloseTime"] = "IBlindOpenCloseTime";
    DeviceResponseType["BlindPosition"] = "IBlindPosition";
    DeviceResponseType["BlindRemoteButtonState"] = "IBlindsControlButton";
    DeviceResponseType["BlindErrorState"] = "IBlindError";
    DeviceResponseType["MeasuredBrightness"] = "IBrightness";
    DeviceResponseType["RemoteButtonState"] = "IButtonState";
    DeviceResponseType["ChannelOnOffState"] = "IChannelOnOff";
    DeviceResponseType["IntercomState"] = "IIntercom";
    DeviceResponseType["DoorBellState"] = "IDoorBell";
    DeviceResponseType["FacadeRemoteButtonState"] = "IFacadeControlButton";
    DeviceResponseType["FacadePosition"] = "IFacadeState";
    DeviceResponseType["FacadeType"] = "IFacadeType";
    DeviceResponseType["FloodSensorState"] = "IFloodSensor";
    DeviceResponseType["GatePosition"] = "IGatePosition";
    DeviceResponseType["GatewayPosition"] = "IGatewayPosition";
    DeviceResponseType["GateControllerHealth"] = "IGateControllerHealth";
    DeviceResponseType["HumiditySensorState"] = "IHumiditySensor";
    DeviceResponseType["LightBrightness"] = "ILightBrightness";
    DeviceResponseType["LightColor"] = "ILightColor";
    DeviceResponseType["LightWarmth"] = "ILightTemperature";
    DeviceResponseType["LightTreshold"] = "ILightTreshold";
    DeviceResponseType["MovementSensorState"] = "IMovementSensor";
    DeviceResponseType["OnlineCamera"] = "IOnlineCamera";
    DeviceResponseType["OvercurrentProtectionState"] = "IOvercurrentProtection";
    DeviceResponseType["OvercurrentProtectionThreshold"] = "IOvercurrentProtectionThreshold";
    DeviceResponseType["ReedState"] = "IReedState";
    DeviceResponseType["SignalStrength"] = "ISignalStrength";
    DeviceResponseType["SmokeSensorState"] = "ISmokeSensor";
    DeviceResponseType["MeasuredTemperature"] = "ITemperature";
    DeviceResponseType["VibrationSensorState"] = "IVibrationSensor";
    DeviceResponseType["MeasuredWindSpeed"] = "IWindSpeed";
    DeviceResponseType["WindThreshold"] = "IWindThreshold";
    DeviceResponseType["MeasuredEnergy"] = "IEnergy";
    DeviceResponseType["MeasuredDistance"] = "DistanceSensor";
    DeviceResponseType["BlindCalibration"] = "BlindCalibration";
    DeviceResponseType["ConfigurationState"] = "ConfigurationState";
    DeviceResponseType["CurrentWindThreshold"] = "CurrentWindThreshold";
    DeviceResponseType["CurrentLightThreshold"] = "CurrentLightThreshold";
    DeviceResponseType["WindSpeedState"] = "WindSpeed";
    DeviceResponseType["TamperProtectionState"] = "ITamperProtection";
    DeviceResponseType["PressureSensorState"] = "IPressureSensor";
    DeviceResponseType["LightRGBWState"] = "ILightRGBW";
    DeviceResponseType["SceneExecuted"] = "ISceneExecuted";
    DeviceResponseType["HallState"] = "IHallState";
    DeviceResponseType["Intercom"] = "IIntercom";
})(DeviceResponseType || (DeviceResponseType = {}));
export var DeviceState;
(function (DeviceState) {
    DeviceState[DeviceState["NotResponding"] = 0] = "NotResponding";
    DeviceState[DeviceState["Working"] = 1] = "Working";
    DeviceState[DeviceState["Broken"] = 2] = "Broken";
    DeviceState[DeviceState["FirmareUpgradeMode"] = 3] = "FirmareUpgradeMode";
})(DeviceState || (DeviceState = {}));
export var CommunicationWay;
(function (CommunicationWay) {
    CommunicationWay[CommunicationWay["TwoWay"] = 1] = "TwoWay";
    CommunicationWay[CommunicationWay["OneWay"] = 2] = "OneWay";
    CommunicationWay[CommunicationWay["ConditionalTwoWay"] = 3] = "ConditionalTwoWay";
})(CommunicationWay || (CommunicationWay = {}));
export var DeviceType;
(function (DeviceType) {
    DeviceType[DeviceType["Unknown"] = -1] = "Unknown";
    DeviceType[DeviceType["Multipurpose"] = 0] = "Multipurpose";
    DeviceType[DeviceType["Controller"] = 1] = "Controller";
    DeviceType[DeviceType["Driver"] = 2] = "Driver";
    DeviceType[DeviceType["Receiver"] = 3] = "Receiver";
    DeviceType[DeviceType["Remote"] = 4] = "Remote";
    DeviceType[DeviceType["Sensor"] = 5] = "Sensor";
    DeviceType[DeviceType["Scene"] = 6] = "Scene";
})(DeviceType || (DeviceType = {}));
export class DeviceTasksInfo {
    constructor() {
        this.DeviceGuid = "";
        this.Channel = 0;
        this.Status = TaskExecution.NoTasksExecuting;
    }
}
export var TaskExecutionResult;
(function (TaskExecutionResult) {
    TaskExecutionResult[TaskExecutionResult["Unknown"] = 0] = "Unknown";
    TaskExecutionResult[TaskExecutionResult["Executed"] = 1] = "Executed";
    TaskExecutionResult[TaskExecutionResult["ResponseTimeout"] = 2] = "ResponseTimeout";
    TaskExecutionResult[TaskExecutionResult["TaskRepeatedAndExecuted"] = 3] = "TaskRepeatedAndExecuted";
    TaskExecutionResult[TaskExecutionResult["TaskRepeatedResponseTimeout"] = 4] = "TaskRepeatedResponseTimeout";
    TaskExecutionResult[TaskExecutionResult["FlowControlNotAvailable"] = 5] = "FlowControlNotAvailable";
    TaskExecutionResult[TaskExecutionResult["ExecutionError"] = 6] = "ExecutionError";
})(TaskExecutionResult || (TaskExecutionResult = {}));
//# sourceMappingURL=IDevice.js.map